/**
 * Kapitał rat w podglądzie harmonogramu w zależności od kolejności zaliczania wpłat.
 *
 * capital_first: każda rata w całości pomniejsza kapitał (kapitał kolejnej raty = kapitał - suma rat wcześniejszych).
 * interest_first: planowa wpłata raty najpierw zaspokaja odsetki umowne naliczone do dnia raty
 * (w tym niespłacone z poprzednich okresów), a dopiero reszta pomniejsza kapitał - kapitał maleje
 * wolniej, odsetki kolejnych okresów są wyższe. Lustrzane odbicie symulacji w Installments.php.
 *
 * Zwraca tablicę części kapitałowych (ile z każdej raty faktycznie schodzi z kapitału).
 */
export function capitalParts(installments, paymentAllocation) {
  let interestDue = 0;
  return installments.map((installment) => {
    const fee = Number(installment.installment_fee) || 0;
    if (paymentAllocation !== 'interest_first') {
      return fee;
    }
    interestDue += Number(installment.interest) || 0;
    const interestPaid = Math.min(fee, interestDue);
    interestDue -= interestPaid;
    return fee - interestPaid;
  });
}
